import type { PropsWithChildren } from 'react';

export const LoadingSkeleton = ({ children }: PropsWithChildren) => (
  <div aria-busy="true">
    <div aria-hidden="true">{children}</div>
  </div>
);
